import Marquee from "react-fast-marquee";

/**
 * Slow editorial marquee — single line, serif, gold accent.
 */
export default function EditorialMarquee() {
  const words = [
    "BBFIT Studio",
    "Metodo",
    "Percorso",
    "Risultato",
    "Personal Training",
    "Su Misura",
    "Conegliano",
  ];
  return (
    <div className="marquee-row bg-obsidian" data-testid="editorial-marquee">
      <Marquee speed={22} autoFill gradient={false} pauseOnHover={false}>
        {words.map((w, i) => (
          <span
            key={i}
            className="font-serif italic font-light text-[9vw] md:text-[7vw] text-cream/85 py-4 md:py-6 flex items-center"
          >
            <span className="mx-10">{w}</span>
            <span className="text-gold text-4xl md:text-5xl leading-none">·</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
